/** Bump with the newest editorial note in product-updates.ts. Public UI preference only. */
export const LATEST_PRODUCT_UPDATE_ID = '2026-11-02-connected-activity';
export const DOCUMENTS_PRODUCT_UPDATE_ID = '2026-11-03-opportunity-documents';
export const PROFITABILITY_REVIEW_PRODUCT_UPDATE_ID = '2026-11-02-reliable-estimate-review';
export const PROFITABILITY_ASSIST_PRODUCT_UPDATE_ID = '2026-11-02-reviewed-deal-revenue';
export const PROFITABILITY_PRODUCT_UPDATE_ID = '2026-10-14-opportunity-profitability';

/** Include server-verified feature availability so newly accessible notes remain unread. */
export function productUpdateReadId(profitabilityAvailable: boolean, documentsAvailable = false) {
  const base = profitabilityAvailable
    ? `${LATEST_PRODUCT_UPDATE_ID}:${PROFITABILITY_PRODUCT_UPDATE_ID}:${PROFITABILITY_ASSIST_PRODUCT_UPDATE_ID}:${PROFITABILITY_REVIEW_PRODUCT_UPDATE_ID}`
    : LATEST_PRODUCT_UPDATE_ID;
  return documentsAvailable ? `${base}:${DOCUMENTS_PRODUCT_UPDATE_ID}` : base;
}
